<template>
  <div
    id="do-service"
    class="flex h-full flex-col justify-between overflow-y-auto"
  >
    <service-detail
      v-if="activeStepProvider"
      class="mx-4"
      :service-name="activeStepProvider.name"
      :details="activeStepProviderDetails"
      :active-step="activeStep"
    />
  </div>
  <webhook-configuration
    v-if="activeStep?.id"
    :webhooks="activeStep.webhooks"
    :step-id="activeStep.id"
  />
  <modal-buttons
    v-if="!isActiveTemplatePublished"
    :on-delete="handleDelete"
    class="border-t bg-disabled py-6"
    :white-background="false"
  />
</template>

<script setup lang="ts">
import { useStore } from "vuex";

import { AnalyticsEvent } from "@/enums/analytics";
import {
  useDataOrchestration,
  useDoActiveTemplateStatus,
} from "@/hooks/orchestration";
import { useAnalyticsStore } from "@/stores/analytics";

import ModalButtons from "@/components/ui/ModalButtons.vue";
import WebhookConfiguration from "@/views/profile/components/dataOrchestration/WebhookConfiguration.vue";
import ServiceDetail from "@/views/profile/components/dataOrchestration/configPanel/ServiceDetail.vue";

const { commit } = useStore();
const { isActiveTemplatePublished } = useDoActiveTemplateStatus();
const {
  activeStep,
  activeStepProvider,
  activeStepProviderDetails,
  activeTemplate,
} = useDataOrchestration();
const { trackEvent } = useAnalyticsStore();

const handleDelete = () => {
  trackEvent(AnalyticsEvent.DataOrchestrationBlockDeleted, {
    template_id: activeTemplate.value?.id,
    step_id: activeStep.value?.id,
    block_title: activeStep.value?.title,
  });
  commit("orchestration/deleteStep", { stepId: activeStep.value?.id });
  commit("orchestration/setActiveConfigPanel", "");
  commit("orchestration/setActiveStep", {});
};
</script>
